module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        // require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function () {

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };


    module.initStickyEl = function () {
        // Select the sticky nav element and its offset
        let el = $('.is-sticky');
        if (!el.length) return; // The landing page header sticks with CSS instead

        let stickyOffset = el.offset().top; // Get initial offset of the sticky element

        // Use requestAnimationFrame for smoother scroll handling
        let isScrolling = false;

        window.addEventListener('scroll', function () {
            if (!isScrolling) {
                window.requestAnimationFrame(function () {
                    module.addStickyClass(stickyOffset); // Pass the sticky element's original offset
                    isScrolling = false;
                });
            }
            isScrolling = true;
        });

        module.addStickyClass(stickyOffset); // Trigger on page load
    };

    module.addStickyClass = function (stickyOffset) {
        let body = $('body');
        let yOffset = window.pageYOffset; // Get current scroll position

        // Check if user has scrolled past the original position of the nav
        if (yOffset >= stickyOffset) {
            body.addClass("stuck").removeClass("before-stuck");
        } else {
            body.removeClass("stuck").addClass("before-stuck");
        }
    };


    module.navDropdownHover = function () {

        const parents = document.querySelectorAll(".parent-item");
        const children = document.querySelectorAll(".child-group");
        const wrapper = document.querySelector(".parent-child-wrap");

        let activeChild = null;
        let hideTimeout = null;

        function showChild(parentId) {
            children.forEach(child => {
                if (child.dataset.childId === parentId) {
                    child.classList.add("active");
                    activeChild = child;
                } else {
                    child.classList.remove("active");
                }
            });
        }

        function hideAllChildren() {
            children.forEach(child => child.classList.remove("active"));
            activeChild = null;
        }

        // Hover over parent items
        parents.forEach(parent => {
            parent.addEventListener("mouseenter", () => {
                const parentId = parent.dataset.parentId;
                clearTimeout(hideTimeout);
                showChild(parentId);
            });

            parent.addEventListener("mouseleave", () => {
                hideTimeout = setTimeout(() => {
                    // Check if child is being hovered
                    if (!activeChild || !activeChild.matches(':hover')) {
                        hideAllChildren();
                    }
                }, 150);
            });
        });

        // Handle hovering into the child section itself
        children.forEach(child => {
            child.addEventListener("mouseenter", () => {
                clearTimeout(hideTimeout);
            });

            child.addEventListener("mouseleave", () => {
                hideTimeout = setTimeout(() => {
                    hideAllChildren();
                }, 150);
            });
        });

        // If wrapper loses hover entirely
        if (wrapper) {
            wrapper.addEventListener("mouseleave", () => {
                hideTimeout = setTimeout(() => {
                    hideAllChildren();
                }, 150);
            });
        }

    };


    module.announcementBarDismiss = function () {
        if ($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };


    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        // One task per carousel - setting them all up at once was the longest
        // block of work on page load (Total Blocking Time)
        const slick = function (selector, options) {
            const el = $(selector);
            if (el.length) setTimeout(() => el.slick(options), 0);
        };

        slick('.slick.testimonials', {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            cssEase: 'linear',
            prevArrow: $('.testi-prev'),
            nextArrow: $('.testi-next'),
        });

        slick('.slick.shortcode-slider', {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        slick('.slick.slides', {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: true,
            fade: true,
            cssEase: 'linear',
        });

        slick('.slick.carousel', {
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            draggable: false,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });

        slick('.slick-carousel.testimonial-cards', {
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            arrows: true,
            cssEase: 'linear',
            prevArrow: $('.testi-prev'),
            nextArrow: $('.testi-next'),

            responsive: [

                {
                    breakpoint: 992, // sm
                    settings: {
                        slidesToShow: 1
                    }
                },

            ]


        });

        slick('.slick.subpages', {
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '2em',
            draggable: true,
            arrows: true,
            dots: false,
            prevArrow: $('.service-prev'),
            nextArrow: $('.service-next'),

            responsive: [
                {
                    breakpoint: 1350,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: '50px',
                    }
                },

                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    }
                },

                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                    }
                },

                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                    }
                },
            ]
        });

        slick('.slick.awards', {
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            draggable: true,
            arrows: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                },

                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 3,
                    }
                },

                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });

    };


    module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            // Scroll once the page has loaded - content above the target shifts while
            // it loads, and scrolling before and after that made the page jump back
            if (document.readyState === 'complete') {
                this.scrollToElement(el);
            } else {
                $(window).on('load', () => this.scrollToElement(el));
            }
        }
    };

    /*
     * Show a "Sending..." spinner on enquiry form buttons from the moment they're
     * submitted - fetching the reCAPTCHA token, then the emails and MoveMan call,
     * can take several seconds. Also stops impatient double submissions.
     * Listens on window in the capture phase so it runs before the reCAPTCHA
     * template's document listener, which holds back the first submit event.
     */
    module.initFormSubmitState = function () {
        window.addEventListener('submit', function (e) {
            const form = e.target;
            if (!form.matches('form[action*="automated-enquiry"]')) return;

            const button = form.querySelector('[type="submit"]');
            if (!button || button.classList.contains('is-sending')) return;

            button.dataset.label = button.innerHTML;
            button.classList.add('is-sending');
            button.setAttribute('aria-disabled', 'true');
            button.innerHTML = '<span class="btn-spinner" aria-hidden="true"></span> Sending&hellip;';
        }, true);

        // Swallow repeat clicks while sending (a disabled button wouldn't be
        // submittable by the reCAPTCHA template's requestSubmit())
        document.addEventListener('click', function (e) {
            if (e.target.closest('.is-sending')) e.preventDefault();
        }, true);

        // Coming back to the page via the back button restores it from cache
        // with the button still spinning - reset it
        window.addEventListener('pageshow', function (e) {
            if (!e.persisted) return;
            document.querySelectorAll('.is-sending').forEach(function (button) {
                button.classList.remove('is-sending');
                button.removeAttribute('aria-disabled');
                button.innerHTML = button.dataset.label;
            });
        });
    };

    /*
     * On the PPC landing pages, point the "Get Your Free Quote" / "Contact Us"
     * buttons and links in CMS content at the quote form in the hero rather
     * than /contact. Buttons in templates (header, contact CTA) already link to it
     */
    module.initQuoteFormLinks = function () {
        const form = document.getElementById('ppc-quote-form');
        if (!form) return;

        const contactPath = new URL(form.dataset.contactUrl, window.location.href).pathname;

        // CMS content sometimes links with the absolute live URL
        const bareHost = host => host.replace(/^www\./, '');
        const siteHosts = [window.location.hostname, form.dataset.siteHost].map(bareHost);

        // Not the footer's site navigation
        document.querySelectorAll('a[href]:not(footer a)').forEach(function (link) {
            if (link.pathname === contactPath && siteHosts.includes(bareHost(link.hostname))
                && /free quote|contact us/i.test(link.textContent)) {
                link.setAttribute('href', '#ppc-quote-form');
                link.removeAttribute('target'); // Some CMS links open in a new tab
            }
        });
    };

    module.scrollToElement = function (element) {
        if (!$(element).length) return;

        // Native scroll rather than $('html,body').animate() - the CSS
        // scroll-behavior: smooth on <html> fights jQuery's per-frame
        // scrollTop updates and the page never leaves the top. Smooth scrolling
        // doesn't run in a background tab, so jump straight there instead
        const top = $(element).offset().top - 100;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (document.visibilityState === 'visible' && !reduceMotion) {
            window.scrollTo({top: top, behavior: 'smooth'});
        } else {
            const html = document.documentElement;
            html.style.scrollBehavior = 'auto';
            window.scrollTo(0, top);
            html.style.scrollBehavior = '';
        }

        if ($(element).next().hasClass('collapse')) {
            $(element).next().collapse('show');
        }
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };


    module.addActiveSlide = function () {


        const slides = document.querySelectorAll(".flexbox-slide");

        slides.forEach((slide) => {
            slide.addEventListener("click", function (event) {
                // Prevent click from propagating to the document (to avoid immediate removal)
                event.stopPropagation();

                // Remove active class from all slides
                slides.forEach((s) => s.classList.remove("active"));

                // Add active class to the clicked slide
                this.classList.add("active");
            });
        });

        // Remove the active class when clicking anywhere else
        document.addEventListener("click", function () {
            slides.forEach((slide) => slide.classList.remove("active"));
        });

    };


    return module;

};
